module.exports = __webpack_public_path__ + "img/ico_senha.68e47b6c.svg";